import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private http: HttpClient) {}

  exportDataPatients(
    customers_id: number,
    options: { sites: number[] } = {
      sites: [],
    }
  ) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/data/export/patients`,
      options
    );
  }

  exportDataAppointments(
    customers_id: number,
    options: { sites: number[]; startDate: Date; endDate: Date } = {
      sites: [],
      startDate: new Date(),
      endDate: new Date(),
    }
  ) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/data/export/appointments`,
      options
    );
  }
}
